/*
  PriceInfo_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { number, string } from 'prop-types'

export default {
  text: string,
  index: number,
}
